import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PageTypeEnum } from 'src/app/enums/PageTypeEnum';
import { LGCouncil } from 'src/app/models/LGCouncil';
import { LGE } from 'src/app/models/LGE';
import { LgElectionService } from 'src/app/services/lg-election.service';

@Component({
  selector: 'app-side-menu-lge',
  templateUrl: './side-menu-lge.component.html',
  styleUrls: ['./side-menu-lge.component.scss']
})
export class SideMenuLgeComponent implements AfterViewInit, OnDestroy {

  private componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  public selectedCouncil: LGCouncil | null = null;
  public lge: LGE | null = null;

  constructor(public lgElectionService: LgElectionService) { 
    this.lgElectionService.menuLoaded$.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
      this.loadMenu();
    });

  }



  ngAfterViewInit(): void {
    //if (this.lgElectionService.electionDates.length > 0) {
  //    this.loadMenu(this.lgElectionService.electionDate);
   // }
   //this.showCouncils();
  }


  private loadMenu(): void {
    this.showCouncils();
  }


  private showCouncils(): void {
    const foundElectionEvent = this.lgElectionService.electionEvents.find(x => x.showCouncils === true);
    if (foundElectionEvent) {
      this.lge = this.lgElectionService.getLGE(foundElectionEvent.electionDate);
      this.selectedCouncil = this.lge?.councils[0] ?? null;

      if (this.lgElectionService.selectedPage?.pageType === PageTypeEnum.Loading) {
         this.lgElectionService.updatePage(
          foundElectionEvent.electionDate,   
          PageTypeEnum.LGEResults,
          '',
          new Date(foundElectionEvent.electionDate)
        );
      }
    }
  }


  public buttonElectionEventClick(electionDate: string): void {
    this.lgElectionService.electionEvents.forEach(electionEvent => {
      if (electionEvent.electionDate === electionDate) {
        if (electionEvent.showCouncils === true) {
          electionEvent.showCouncils = false;
        } else {
          electionEvent.showCouncils = true;
          this.selectedCouncil = this.lge?.councils[0] ?? null;
        }
      } else if (electionEvent.showCouncils === true) {
        electionEvent.showCouncils = false;
      }
    });
    this.showCouncils();
  }


  public clickCouncil(council: LGCouncil): void {
    this.lgElectionService.checkMenu();
    this.lgElectionService.currentCouncil = council;
    this.selectedCouncil = council;
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }


}
